import { useRef } from 'react';
import { useDecorativeVideo } from 'common/hook/useDecorativeVideo';
import { useHeroIntroAnimation } from 'common/hook/useHeroIntroAnimation';
import { useTranslation } from 'next-i18next';

interface Props {
  isProject?: boolean;
}

export const HeroContact: React.FC<Props> = ({ isProject }) => {
  const { t } = useTranslation('pageContact');
  const el = useRef<HTMLElement | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  useHeroIntroAnimation({
    scopeRef: el,
    revealAnimations: [
      { delay: 1.8, selector: '#hero-text', toVars: { opacity: 1, translateY: 0 } },
      { delay: 2, selector: '#hero-button', toVars: { opacity: 1, translateY: 0 } },
    ],
  });
  useDecorativeVideo(videoRef);

  if (isProject) {
    return (
      <section
        ref={el}
        className="bg-gradient top-0 flex min-h-[100vh] w-[100vw] flex-col items-center justify-center overflow-hidden pb-6 pt-48 md:sticky md:pt-32 lg:pb-10 lg:pt-32">
        <video
          ref={videoRef}
          className="absolute bottom-0 right-0 h-full w-[100vw] object-cover"
          loop
          autoPlay
          muted
          playsInline
          preload="metadata"
          aria-hidden="true"
          tabIndex={-1}
          disablePictureInPicture
          role="presentation">
          <source
            src="https://firebasestorage.googleapis.com/v0/b/nordit-83a0b.appspot.com/o/heroVideo.mp4?alt=media&token=5544cf62-e98e-4a23-8ef3-99ccee509131"
            type="video/mp4"
          />
        </video>
        <div className="bg-gradient absolute bottom-0 left-0 right-0 top-0 opacity-[0.96]" />
        <div className="container">
          <h1
            id="hero-title"
            className="text-heading-hero"
            dangerouslySetInnerHTML={{ __html: t('hero.project.title') }}
          />

          <div
            id="hero-text"
            className="mb-10 mt-10 max-w-lg translate-y-4 opacity-0"
            dangerouslySetInnerHTML={{ __html: t('hero.project.description') }}
          />

          <div className="max-w-[820px] rounded-[24px] border border-white/10 bg-white/[0.04] p-6 lg:p-8">
            <div className="mb-5 font-semibold uppercase text-primary">
              {t('hero.project.nextSteps.title')}
            </div>
            <div className="grid gap-3 lg:grid-cols-3">
              {(t('hero.project.nextSteps.items', { returnObjects: true }) as string[]).map(
                item => (
                  <div
                    key={item}
                    className="rounded-[18px] border border-white/10 bg-black/10 p-4 text-white/86">
                    {item}
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section
      ref={el}
      className="bg-gradient top-0 flex min-h-[100vh] w-[100vw] flex-col items-center justify-center overflow-hidden pb-6 pt-48 md:sticky md:pt-32 lg:pb-10 lg:pt-32">
      <video
        ref={videoRef}
        className="absolute bottom-0 right-0 h-full w-[100vw] object-cover"
        loop
        autoPlay
        muted
        playsInline
        preload="metadata"
        aria-hidden="true"
        tabIndex={-1}
        disablePictureInPicture
        role="presentation">
        <source
          src="https://firebasestorage.googleapis.com/v0/b/nordit-83a0b.appspot.com/o/heroVideo.mp4?alt=media&token=5544cf62-e98e-4a23-8ef3-99ccee509131"
          type="video/mp4"
        />
      </video>
      <div className="bg-gradient absolute bottom-0 left-0 right-0 top-0 opacity-[0.96]" />
      <div className="container">
        <h1
          id="hero-title"
          className="text-heading-hero"
          dangerouslySetInnerHTML={{ __html: t('hero.notProject.title') }}
        />

        <div
          id="hero-text"
          className="mb-10 mt-10 max-w-xl translate-y-4 opacity-0"
          dangerouslySetInnerHTML={{ __html: t('hero.notProject.description') }}
        />
      </div>
    </section>
  );
};
